import Vue from "vue";
import Router from "vue-router";
import index from "@/view/index.vue";
import newIndex from "@/view/newIndex.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/newIndex",
      name: "newIndex",
      component: newIndex,
    },
    {
      path: "/",
      name: "index",
      component: index,
    },
    {
      path: "/member/login",
      name: "login",
      meta: {},
      component: () => import("@/view/member/login.vue"),
    },
    {
      path: "/member/ruler",
      name: "ruler",
      meta: {},
      component: () => import("@/view/member/ruler.vue"),
    },
    {
      path: "/member/register",
      name: "register",
      meta: {},
      component: () => import("@/view/member/register.vue"),
    },
    {
      path: "/member/activityList",
      name: "activityList",
      meta: {},
      component: () => import("@/view/member/activityList.vue"),
    },
    {
      path: "/member/detailsactivity",
      name: "detailsactivity",
      meta: {},
      component: () => import("@/view/member/detailsactivity.vue"),
    },
    {
      path: "/member/forget",
      name: "forget",
      meta: {},
      component: () => import("@/view/member/forget.vue"),
    },
    {
      path: "/member/orderDetail",
      name: "orderDetail",
      meta: {},
      component: () => import("@/view/member/orderDetail.vue"),
    },
    {
      path: "/member/orderPay",
      name: "orderPay",
      meta: {},
      component: () => import("@/view/member/orderPay.vue"),
    },
    {
      path: "/member/wxPay",
      name: "wxPay",
      meta: {},
      component: () => import("@/view/member/wxPay.vue"),
    },
    {
      path: "/member/logisticsDetail",
      name: "logisticsDetail",
      meta: {},
      component: () => import("@/view/member/logisticsDetail.vue"),
    },
    {
      path: "/hotnew",
      name: "hotnew",
      meta: {},
      component: () => import("@/view/Page/hotnews.vue"),
    },
    {
      path: "/newdetails",
      name: "newdetails",
      meta: {},
      component: () => import("@/view/Page/hotnewsComp/newdetails.vue"),
    },
    {
      path: "/notice",
      name: "notice",
      meta: {},
      component: () => import("@/view/Page/hotnewsComp/notice.vue"),
    },
    {
      path: "/performs",
      name: "performs",
      meta: {},
      component: () => import("@/view/Page/performanceComp/performs.vue"),
    },

    {
      path: "/seatsBook",
      name: "seatsBook",
      meta: {},
      component: () => import("@/view/Page/performanceComp/seatsBook.vue"),
    },
    {
      path: "/abstract",
      name: "abstract",
      meta: {},
      component: () => import("@/view/Page/introductionComp/abstract.vue"),
    },
    {
      path: "/originality",
      name: "originality",
      meta: {},
      component: () => import("@/view/Page/creativityComp/originality.vue"),
    },
    {
      path: "/details",
      name: "details",
      meta: {},
      component: () => import("@/view/Page/performanceComp/details.vue"),
    },
    {
      path: "/seatsBook",
      name: "seatsBook",
      meta: {},
      component: () => import("@/view/Page/performanceComp/seatsBook.vue"),
    },
    {
      path: "/changeSeats",
      name: "changeSeats",
      meta: {},
      component: () => import("@/view/Page/performanceComp/changeSeats.vue"),
    },
    {
      path: "/contactus",
      name: "contactus",
      meta: {},
      component: () => import("@/view/Page/assistanceComp/contactus.vue"),
    },
    {
      path: "/catLi",
      name: "catLi",
      meta: {},
      component: () => import("@/view/Page/assistanceComp/catLi.vue"),
    },
    {
      path: "/program",
      name: "program",
      meta: {},
      component: () => import("@/view/Page/programComp/program.vue"),
    },
    {
      path: "/facilities",
      name: "facilities",
      meta: {},
      component: () => import("@/view/Page/programComp/facilities.vue"),
    },
    {
      path: "/connection",
      name: "connection",
      meta: {},
      component: () => import("@/view/Page/programComp/connection.vue"),
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js